__webpack_require__.p = "https://docscout-beta.dba.legal.amazon.dev/";